<template>
    <div class="receipt-illegalUnload-upload" v-loading="loading">
        <!-- 已上传过图片 -->
        <template v-if="imgList.length > 0">
            <div style="margin-bottom: 15px">
                <span style="margin-right: 5px">
                    {{ currentData.updateUserName }}
                </span>
                在
                <span style="margin: 0 10px">
                    {{ currentData.updateTime }} </span
                >上传
            </div>
            <div class="fileName-text">
                {{ currentData.name }}
            </div>
            <div style="height: 220px; width: 80%; margin-left: 10%;">
                <ul id="viewers" style="display: none">
                    <li v-for="(item, index) in srcList" :key="index">
                        <img :src="item" />
                    </li>
                </ul>
            </div>
            <div class="currentImgIndex">
                {{ carouselIndex + 1 + ' / ' + imgList.length }}
            </div>
            <div class="uploader">
                <performance-common-upload
                    ref="performanceCommonUpload"
                    :type="'icon'"
                    :icon="'el-icon-plus pictures'"
                    :showFileList="false"
                    :accept="'.jpg,.jpeg,.png,.avi,.wmv,.mpg,.mpeg,.mov,.mkv,.3gp,.flv,.mp4'"
                    :multiple="true"
                    :disabled="loading"
                    :compressImage="true"
                    :maxSize="100"
                    @beforeUpload="beforeUpload"
                    @callback="uploadResponse"
                ></performance-common-upload>
                <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click="handleDeleteImage"
                    :loading="delLoading"
                ></el-button>
                <el-button
                    type="text"
                    icon="el-icon-download"
                    @click="handleDownload"
                ></el-button>
            </div>
        </template>
        <!-- 没上传图片时 -->
        <template v-else>
            <div class="noUpload">
                <performance-common-upload
                    ref="performanceCommonUpload"
                    :type="'icon'"
                    :icon="'el-icon-plus notImg'"
                    :showFileList="false"
                    :accept="'.jpg,.jpeg,.png,.avi,.wmv,.mpg,.mpeg,.mov,.mkv,.3gp,.flv,.mp4'"
                    :multiple="true"
                    :compressImage="true"
                    :maxSize="100"
                    @beforeUpload="beforeUpload"
                    @callback="uploadResponse"
                ></performance-common-upload>
            </div>
        </template>
    </div>
</template>
<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import { mapState } from 'vuex';
import _ from 'lodash';
import PerformanceCommonUpload from './performanceCommonUpload.vue';
import { illegalUnloadPicDelete, illegalUnloadPicUpload } from '@/modules/transport/otp/api/performanceReceiptSign.js';
import { filterObjectsByProperty } from '../../util.js';
export default {
    name: 'receiptUpload',
    props: {
        attachmentList: {
            type: Array,
            required: true,
            default () {
                return [];
            }
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    components: {
        PerformanceCommonUpload
    },
    data () {
        return {
            carouselIndex: 0, // 当前图片索引
            loading: false,
            delLoading: false,
            updateUserName: '', // 当前图片更新人
            updateTime: '', // 当前图片更新时间
            srcList: [], // 当前图片列表
            currentData: {}, // 当前显示图片数据
            viewer: {},
            imgList: []
        };
    },
    computed: {
        ...mapState({ user: state => state.user })
    },
    methods: {
        /**
         * @description 上传附件之前
         */
        beforeUpload () {
            this.loading = true;
        },
        /**
         * @description 图片上传成功回调
         * @param {Object} response oss回调数据
         */
        uploadResponse (response) {
            this.loading = true;
            const param = {
                taskNo: this.rowData.taskNo,
                fileUrls: response.map(v => v.fileUrl)
            };
            illegalUnloadPicUpload(param)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.$emit('upload-success');
                        this.$refs.performanceCommonUpload.uploadList = [];
                        this.$refs.performanceCommonUpload.uploadFileList = [];
                    }
                })
                .catch(() => { })
                .finally(() => { this.loading = false; });
        },

        /**
         * @description 删除图片
         */
        handleDeleteImage () {
            if (this.attachmentList.length === 0) {
                return this.$message.warning('暂无附件上传');
            }
            this.loading = true;
            this.delLoading = true;
            const param = {
                taskNo: this.rowData.taskNo,
                filePath: this.currentData.path
            };
            if (!param.filePath) {
                this.$emit('delete-success');
                return this.$message.success('删除成功');
            };
            illegalUnloadPicDelete(param)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功');
                    }
                })
                .catch(() => {
                    this.$message.error('删除失败');
                })
                .finally(() => {
                    this.$emit('delete-success');
                    this.delLoading = false;
                    this.loading = false;
                });
        },

        // 下载图片
        handleDownload () {
            window.location = this.currentData.path;
        },

        /**
         * @description 切换图片时，更新图片上传信息
         * @param {Number} index 当前显示图片索引
         */
        updateInfo (index) {
            this.carouselIndex = index;
            this.currentData = this.imgList[index];
        },

        // 初始化viewer组件
        initViewer (resolve) {
            if (this.srcList.length > 0) {
                const barOptions = { show: true, size: 'default' };
                this.viewer = new Viewer(document.getElementById('viewers'), {
                    title: false,
                    inline: true,
                    navbar: true,
                    focus: false, // 关闭页面自动定位到viewer
                    zIndexInline: 10086,
                    backdrop: true, // 透明背景色
                    zoomOnWheel: true, // 滚动缩放
                    toolbar: {
                        zoomIn: barOptions,
                        zoomOut: barOptions,
                        oneToOne: barOptions,
                        reset: barOptions,
                        prev: {
                            show: true,
                            size: 'default',
                            click: () => {
                                if (this.carouselIndex === 0) {
                                    return this.$message.warning('当前图片是第一张');
                                } else {
                                    this.carouselIndex -= 1;
                                    this.viewer.prev(true);
                                }
                            }
                        },
                        play: barOptions,
                        next: {
                            show: true,
                            size: 'default',
                            click: () => {
                                if (this.carouselIndex === this.imgList.length - 1) {
                                    return this.$message.warning('当前图片是最后一张');
                                } else {
                                    this.carouselIndex += 1;
                                    this.viewer.next(true);
                                }
                            }
                        },
                        rotateLeft: barOptions,
                        rotateRight: barOptions,
                        flipHorizontal: barOptions,
                        flipVertical: barOptions

                    },
                    viewed: data => { // 图片加载完成时回调
                        this.updateInfo(data.detail.index);
                        resolve();
                    }
                });
            }
        },
        show () {
            this.viewer.element && this.viewer.destroy(); // 删除viewer上一次的实例
            const copyAttachmentList = _.cloneDeep(this.attachmentList);
            this.imgList = filterObjectsByProperty(copyAttachmentList, 'path');
            this.srcList = this.imgList.map(v => v.path);
            this.dialogVisible = true;
            this.$nextTick(() => {
                new Promise(resolve => {
                    this.initViewer(resolve);
                }).then(() => {});
            });
        }
    }
};
</script>
<style lang="less">
.receipt-illegalUnload-upload {
    text-align: center;
    height: 60%;
    width: 100%;

    .fileName-text {
        width: 100%;
        margin-bottom: 15px;
        overflow: hidden;
        /* 隐藏溢出内容 */
        white-space: nowrap;
        /* 强制内容在一行显示 */
        text-overflow: ellipsis;
        /* 添加省略号 */
    }

    .uploader {
        text-align: center;
        margin-top: 15px;

        .pictures {
            border-radius: 4px;
            border: 1px dashed #00bcbf;
            color: #00bcbf;
            width: 20px;
            line-height: 20px;
            text-align: center;
        }

        .upload-demo {
            display: inline-block;
        }

        .el-button {
            margin-left: 30px;
        }

        .el-icon-delete,
        .el-icon-download,
        .el-icon-loading {
            cursor: pointer;
            color: #00bcbf;
            font-size: 22px;
            vertical-align: middle;
        }
    }

    .noUpload {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
    }

    .notImg {
        border-radius: 4px;
        border: 2px dashed #00bcbf;
        color: #00bcbf;
        font-size: 50px;
        width: 180px;
        line-height: 180px;
        text-align: center;
    }

    .pictures {
        border-radius: 4px;
        border: 1px dashed #00bcbf;
        color: #00bcbf;
        width: 20px;
        line-height: 20px;
        text-align: center;
    }

    #viewers {
        display: none;
    }

    .currentImgIndex {
        margin-top: 8px;
    }

    // .viewer-backdrop {
    //     background-color: transparent;
    // }
    // .viewer-footer {
    //     .viewer-navbar {
    //         display: none;
    //     }
    // }
}

.drawer-modal {
    z-index: 2016;
    position: fixed;
    top: 40%;
    right: 0;
    color: #fff;
    border: 1px solid rgb(0, 188, 191);
    background-color: rgb(0, 188, 191);
}

.good-list-modal {
    z-index: 2016;
    position: fixed;
    top: 50px;
    bottom: 0;
    right: 0;
    width: 50%;
    text-align: left;
    border-radius: 20px 0 0 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    transition: right 1s ease;
    background: #fff;

    .el-icon-close {
        cursor: pointer;
        font-size: 24px;
        margin: 10px 0 0 5px;
    }

    .good-main {
        margin-top: 20px;
    }
}

.sidebar-enter-active,
.sidebar-leave-active {
    transition: all 0.5s;
}

.sidebar-enter,
.sidebar-leave-to {
    transform: translateX(100%);
}
</style>
